import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  CookieConsentService,
  PreferenciasCookies,
} from '../../_services/cookie-consent.service';
import { DxCheckBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, DxCheckBoxComponent],
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent {
  mostrarBanner = !this.cookieConsent.haRespondido();
  mostrarConfigurador = false;

  preferencias: PreferenciasCookies = {
    analisis: false,
    terceros: false,
  };

  constructor(private cookieConsent: CookieConsentService) {
    this.cookieConsent.solicitudApertura.subscribe(() => this.reabrir());
  }

  abrirConfigurador(): void {
    this.preferencias = { ...this.cookieConsent.obtenerPreferencias() };
    this.mostrarConfigurador = true;
  }

  aceptarTodas(): void {
    this.cookieConsent.aceptarTodas();
    this.cerrar();
  }

  rechazarNoEsenciales(): void {
    this.cookieConsent.rechazarNoEsenciales();
    this.cerrar();
  }

  guardarConfiguracion(): void {
    this.cookieConsent.guardarPreferencias(this.preferencias);
    this.cerrar();
  }

  reabrir(): void {
    this.mostrarBanner = true;
    this.abrirConfigurador();
  }

  private cerrar(): void {
    this.mostrarBanner = false;
    this.mostrarConfigurador = false;
  }
}
